import { useState } from "react";
import { Avatar, Box, Stack, Typography } from "@mui/material";
import { Verified } from "@mui/icons-material";
import UserProfileDrawer from "@/components/UserProfileDrawer";
import { renderTextWithMentions } from "@/utils/mentions";
import { formatDate } from "@/utils/time";
export default function CaptionContainer({ content }) {
  const [showUser, setShowUser] = useState(false);

  return (
    <>
      {content.meta.text && (
        <Stack direction="row" alignItems="flex-start" spacing={1}>
          <UserProfileDrawer
            userKey={content.owner.key}
            userProfile={content.owner.meta.profile}
            avatarSize={34}
          />

          <Box id="post-content-container" style={{ width: "100%" }}>
            <Box
              id="post-header"
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "flex-start",
                marginTop: "-5px",
              }}
            >
              <Box
                id="user-detail"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                }}
              >
                <Typography
                  variant="body"
                  style={{ marginRight: "5px", fontWeight: "bold" }}
                >
                  {content.owner.name}
                </Typography>

                {content.owner.role == "artist" && (
                  <Verified
                    color={content.owner.verified ? "secondary" : "disabled"}
                    style={{ fontSize: "15px", marginRight: "5px" }}
                  />
                )}

                {content.owner.role == "user" && content.owner.verified && (
                  <Verified
                    color="primary"
                    style={{ fontSize: "15px", marginRight: "5px" }}
                  />
                )}

                <Typography
                  variant="caption"
                  style={{ marginRight: "5px", color: "lightgray" }}
                  // sx={{mt: 0.5, ml: 0.5}}
                >
                  {/* {console.log(content)} */}
                  {formatDate(content.live)}
                </Typography>
              </Box>
            </Box>

            <Box
              id="post-content"
              style={{ marginTop: "-5px" }}
              // onClick={goToThread}
            >
              {/* needs to wrap long comment */}
              <Box style={{ wordWrap: "break-all", whiteSpace: "pre-wrap" }}>
                <Typography variant="body" style={{ marginRight: "5px" }}>
                  {renderTextWithMentions(content.meta.text)}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Stack>
      )}
    </>
  );
}
